export var getUTCTime = function (dateAndTime) {
    var date = new Date(dateAndTime).toUTCString();
    return date.substring(17);
};
// UTC Format - Www, dd Mmm yyyy hh:mm:ss GMT
export var getUTCDate = function (dateAndTime) {
    var date = new Date(dateAndTime).toUTCString();
    return date.substring(0, 17);
};
export var getElapsedTime = function (startTime, endTime) {
    var startDateUTC = new Date(startTime).toUTCString();
    var endDateUTC = new Date(endTime).toUTCString();
    var seconds = (new Date(endDateUTC).getTime() - new Date(startDateUTC).getTime()) / 1000;
    return Math.floor(seconds / 60) + "min " + (seconds % 60) + "sec";
};
